import { Outlet, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function Layout() {
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--body-color)' }}>
      <header style={{ backgroundColor: 'black' }}>
        <div className="w-full">
          <Link to="/" className="block">
            <img
              src="/images/header.png"
              alt="When Disco Goes Wrong"
              className="w-full max-w-[975px] h-auto mx-auto"
              style={{ maxHeight: '180px', objectFit: 'contain', display: 'block' }}
            />
          </Link>
        </div>
        <nav style={{ backgroundColor: 'var(--navbar-bg-color)' }}>
          <div className="container mx-auto px-4 py-3 flex justify-between items-center">
            <div className="flex gap-6 items-center">
              <Link to="/artists" className="text-black font-medium hover:opacity-80 transition-opacity">
                Artists
              </Link>
              <Link to="/releases" className="text-black font-medium hover:opacity-80 transition-opacity">
                Releases
              </Link>
              {user?.isAdmin && (
                <Link to="/admin" className="text-black font-medium hover:opacity-80 transition-opacity">
                  Admin
                </Link>
              )}
            </div>
            <div className="flex gap-4 items-center">
              {user && (
                <>
                  <span className="text-black text-sm">{user.email}</span>
                  <button
                    onClick={logout}
                    className="px-4 py-1.5 rounded text-sm font-medium transition-colors"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </nav>
      </header>
      <main className="flex-1 container mx-auto px-4 py-8">
        <Outlet />
      </main>
      <footer className="text-center py-6" style={{ backgroundColor: 'black', color: 'white' }}>
        <p>When Disco Goes Wrong est. 2020. Acid to the people!</p>
      </footer>
    </div>
  )
}
